import DetailHeroSection from "@/components/Future Mentor/DetailHeroSection";
import Footer from "@/components/Index/Footer";
import Navbar from "@/components/Index/Navbar";

export default function FutureMentorDetail() {
  return (
    <>
      <Navbar />
      <DetailHeroSection />
      <Footer />
    </>
  );
}
